import React from "react";
import { motion } from "framer-motion";
import {cn} from "@core-ui-lib/utils.ts";

interface SocialOrbitProps {
  children?: React.ReactNode;
  rippleCount?: number;
  rippleDuration?: number;
  orbitDuration?: number;
  size?: number;
  className?: string;
}

export function SocialOrbit({
  children,
  rippleCount = 5,
  rippleDuration = 2,
  size = 500,
  className = "",
}: SocialOrbitProps) {

  const baseInset = 40;
  const rippleBoxes = Array.from({ length: rippleCount }, (_, i) => {
    const insetPercent = baseInset - i * 8;
    const radiusPercent = 50 - insetPercent;
    return {
      inset: `${insetPercent}%`,
      radius: (size / 2) * (radiusPercent / 50),
      zIndex: 99 - i,
      delay: i * 0.2,
      opacity: 1 - i * 0.15,
    };
  });

  return (
    <div className={cn("relative", className)} style={{ width: size, height: size }}>
      <div className="absolute inset-0">
        {rippleBoxes.map((box, i) => (
          <motion.div
            key={`ripple-${i}`}
            className="absolute rounded-full bg-gradient-to-b from-muted/10 to-muted/20"
            style={{
              width: box.radius * 2,
              height: box.radius * 2,
              left: "50%",
              top: "50%",
              marginLeft: -box.radius,
              marginTop: -box.radius,
              zIndex: box.zIndex,
              opacity: box.opacity,
                backgroundColor: `color-mix(in oklch, var(--primary) ${box.opacity * 35}%, transparent)`,
            }}
            animate={{
              scale: [1, 1.15, 1],
              boxShadow: [
                "rgba(0,0,0,0.3) 0px 10px 10px 0px",
                "rgba(0,0,0,0.3) 0px 30px 20px 0px",
                "rgba(0,0,0,0.3) 0px 10px 10px 0px",
              ],
            }}
            transition={{
              repeat: Infinity,
              duration: rippleDuration,
              delay: box.delay,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      {children && (
        <div className="absolute inset-0 flex items-center justify-center z-[200] pointer-events-none">
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            {children}
          </motion.div>
        </div>
      )}

    </div>
  );
}
